/**
 * Design System - Theme Configuration
 *
 * Theme definitions for light and dark modes
 */

import { colors } from '../tokens/colors';
import { typography } from '../tokens/typography';
import { spacing } from '../tokens/spacing';
import { borders } from '../tokens/borders';
import { shadows } from '../tokens/shadows';

// Define a flexible Theme type that accepts any color values
export interface Theme {
  colors: {
    brand: Record<string, string>;
    background: Record<string, string>;
    typography: Record<string, string>;
    stroke: Record<string, string>;
    status: Record<string, Record<string, string>>;
    gray: Record<string, string>;
    overlay: Record<string, string>;
    base: Record<string, string>;
  };
  typography: typeof typography;
  spacing: typeof spacing;
  borders: typeof borders;
  shadows: typeof shadows;
}

export const lightTheme: Theme = {
  colors: {
    ...colors,
  },
  typography,
  spacing,
  borders,
  shadows,
};

export const darkTheme: Theme = {
  colors: {
    ...colors,
    // Override colors for dark mode
    background: {
      primary: '#1C1917',
      secondary: '#292524',
      offset: '#292524',
      shade: '#44403C',
      alternate: '#FFFFFF',
    },
    typography: {
      primary: '#FFFFFF',
      secondary: '#E7E5E4',
      tertiary: '#A8A29E',
      placeholder: '#A8A29E',
      alternate: '#1C1917',
      text: '#D6D3D1',
      'alt-offset': '#E7E5E4',
    },
  },
  typography,
  spacing,
  borders,
  shadows,
};

// Default export
export const theme = lightTheme;
